import { PageLayout } from '@/components/PageLayout';
import { Outlet, useNavigate } from 'react-router-dom';
import BreadCrumbsHeader from '@/components/BreadCrumbsHeader';
import { useContext, useEffect } from 'react';
import { NavContext } from '@/components/NavContext';
import { useMobile } from '@/util';
import { manageSidebar } from '../../constants/sidebar.constants';
import SidebarNavigation from '@/components/SidebarNavigation';
import { Userwithorganisationwithidps } from '@/models';
import { AuthContext } from '@/components/Contexts/AuthContext';
import i18n from 'i18next';

function ManagePage() {
  const { collapsed, navDisabled, submenu } = useContext(NavContext);
  const isMobile = useMobile();
  const showNav = !navDisabled && ((submenu && !collapsed) || !isMobile);
  const showContent = collapsed || !isMobile;
  const navigate = useNavigate();

  //insufficiënt role redirect
  const { auth } = useContext(AuthContext);
  const authUser = auth?.user as Userwithorganisationwithidps;
  useEffect(() => {
    const role = Math.max(
      authUser?.activeOrganisationRole || 0,
      authUser?.role || 0
    );
    if (role <= 50) {
      navigate(`/${i18n.language}/noaccess`);
    }
  }, []);

  if (navDisabled) return <Outlet />;

  return (
    <PageLayout>
      {showNav && (
        <PageLayout.Sidebar>
          <SidebarNavigation items={manageSidebar} />
        </PageLayout.Sidebar>
      )}
      <div
        className={`${
          showContent ? '' : 'hidden'
        } mx-auto min-h-[100vh] w-full max-w-6xl lg:min-h-[calc(100vh_-_150px)]`}
      >
        <PageLayout.Content>
          {!isMobile && <BreadCrumbsHeader />}
          <Outlet />
        </PageLayout.Content>
      </div>
    </PageLayout>
  );
}

export default ManagePage;
